import { MustShow } from "@repo/core/components/core/MustShow";
import { ProfessionalAccordionProps } from "./types";
import { AccordionContainer } from "@repo/core/components/layout/ProposalAccordion/components/AccordionContainer";
import { InfoSection } from "@repo/core/components/layout/ProposalAccordion/components/InfoSection";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import {
  ProposalTypeEnum,
  proposalTypeOptions
} from "@repo/core/screens/ProposalEffectiveFlows/Credit/DetailsCreditProposal/consts";

export const ProfessionalAccordion = ({
  professionalCategory,
  profession,
  admissionDate,
  proposalType,
  income,
  ...rest
}: ProfessionalAccordionProps) => {
  return (
    <AccordionContainer {...rest}>
      <MustShow
        isVisible={
          proposalType !== proposalTypeOptions[ProposalTypeEnum.FIDELITY]
        }
      >
        <InfoSection title="Classe profissional" value={professionalCategory} />
      </MustShow>
      <InfoSection title="Profissão" value={profession} />
      <MustShow
        isVisible={
          proposalType !== proposalTypeOptions[ProposalTypeEnum.FIDELITY]
        }
      >
        <InfoSection title="Data de Admissão" value={admissionDate} />
        <InfoSection title="Renda" value={numberToBrl(parseFloat(income))} />
      </MustShow>
    </AccordionContainer>
  );
};
